import 'bootstrap';
import * as $ from "jquery";

export default (function () {
  let $formContainer = $('.settings-form');

  if (0 < $formContainer.length) {
    function renderImageUploadingForm(selector) {
      $(`${selector} .image-upload`).on('change',function(e){
        $(this).next('.custom-file-label').html(e.target.files[0].name);
      })

      $(`${selector} .image-update`).on('click', function(e) {
        $(e.target).parent().addClass('d-none');
        $(`${selector} .image-upload-input-container`).removeClass('d-none');
      });
    }

    renderImageUploadingForm('.image-logo');
    renderImageUploadingForm('.image-watermark_image');
    
    $formContainer.find('button[type=submit]').on('click', function () {
      $formContainer.find('input[type=file]').each((key, input) => {
        if (!$(input).val()) {
          $formContainer.find(`input[name=${input.name}]`).remove();
        }
      });

      $formContainer.find('form').submit();
    });
  }
}());
